/**
 * Ad experiments (plans/auth-embed-post-deploy-optimizations.md, item 3).
 *
 * Each browser holds a random bucket 0–9 (lib/adExperiments.js), sent to GAM
 * as the key-value `mb` on every display request and Stories ad tag. An
 * experiment's holdout buckets keep the previous behaviour, and GAM reports
 * split revenue on `mb` (CUSTOM_CRITERIA). Edit here and rebuild the SDK.
 */
module.exports = {
  AD_BUCKET_COUNT: 10,
  AD_BUCKET_TARGETING_KEY: 'mb',
  AD_BUCKET_STORAGE_KEY: '__milla_ad_bucket',
  AD_EXPERIMENTS: Object.freeze({
    // 2026-10-05 – 2026-10-13: storiesPreload held bucket 0 out of a
    // page-start Stories bundle preload. No effect on prerolls, so the
    // preload and the experiment were removed; bucket 0 is free again.
    // 2026-10-08: GAM PPID holdout (plans/ads-identity-unification.md).
    // Buckets 8 and 9 send no publisher-provided id; Prebid user ids and
    // consent are unchanged. Compare mb=8,9 with mb=1..7 (0 was the Stories
    // holdout until 2026-10-13). Planned for three weeks from the deploy.
    ppid: Object.freeze({ holdoutBuckets: Object.freeze([8, 9]) })
  })
};
